import React from "react";
import { ITwitterTabProps } from "../InfluencerSocial.types";
import DefaultTab from "./DefaultTab";
// import DetailTab from "./DetailTab";

import { useInfluencerSocialStyle as classes } from "../InfluencerSocial.styles";
import { Box } from "@mui/material";

export default function TwitterTab(props: ITwitterTabProps) {
  const { TabPanel, tabSelected, twitter, matches } = props;
  return (
    <TabPanel value={tabSelected} index={matches ? 4 : 3}>
      <Box sx={classes.tabPanelBox}>{twitter === null && <DefaultTab />}</Box>
    </TabPanel>
  );
}
